"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getShutterstockReducer;

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _Constants = require("FileManagerCore/Constants");

var defaultState = (0, _immutable.Map)({
  results: new _immutable.List(),
  total: 0,
  query: (0, _immutable.Map)({
    page: 1
  }),
  searchStatus: _Constants.RequestStatus.UNINITIALIZED,
  acquireStatus: _Constants.RequestStatus.UNINITIALIZED
});

function getShutterstockReducer(_ref) {
  var concatenateResults = _ref.concatenateResults;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var type = action.type,
        data = action.data,
        query = action.query;

    switch (type) {
      case _ActionTypes.default.RESET_PAGE:
      case _ActionTypes.default.SEARCH_SHUTTERSTOCK_RESET:
        return defaultState;

      case _ActionTypes.default.SEARCH_SHUTTERSTOCK_FAILED:
        return state.set('searchStatus', _Constants.RequestStatus.FAILED);

      case _ActionTypes.default.SEARCH_SHUTTERSTOCK_ATTEMPTED:
        return state.merge({
          searchStatus: _Constants.RequestStatus.PENDING,
          query: query
        });

      case _ActionTypes.default.SEARCH_SHUTTERSTOCK_SUCCEEDED:
        if (query.get('searchQuery') !== state.getIn(['query', 'searchQuery'])) {
          return state;
        }

        return state.merge({
          results: concatenateResults ? state.get('results').concat(data.get('results')) : data.get('results'),
          total: data.get('resultCount'),
          searchStatus: _Constants.RequestStatus.SUCCEEDED,
          query: query
        });

      case _ActionTypes.default.ACQUIRE_IMAGE_FAILED:
        return state.merge({
          acquireStatus: _Constants.RequestStatus.FAILED
        });

      case _ActionTypes.default.ACQUIRE_IMAGE_ATTEMPTED:
        return state.merge({
          acquireStatus: _Constants.RequestStatus.PENDING
        });

      case _ActionTypes.default.ACQUIRE_IMAGE_SUCCEEDED:
        return state.merge({
          acquireStatus: _Constants.RequestStatus.SUCCEEDED
        });

      default:
        return state;
    }
  };
}

module.exports = exports.default;